module.exports = __webpack_public_path__ + "img/4.127e033e.png";